import React from 'react';
import c from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import ThumbStatusIndicator from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicator';
import s from './Card.scss';
const Card = ({ badgeType, children, className })=>{
    return /*#__PURE__*/ React.createElement(Section, {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement(ThumbStatusIndicator, {
        type: badgeType,
        size: "large",
        className: s['badge']
    }), children);
};
Card.displayName = 'Card';
export default Card;
